import React from 'react';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { PrimeReactProvider } from 'primereact/api';
import { Provider } from 'react-redux';
import store from './store/configureStore';
import { BrowserRouter } from 'react-router-dom';
import Main from "./layouts/Main"
import Authenticate from './authenticate/Authenticate';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: process.env.REACT_APP_SETRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  environment: process.env.REACT_APP_ENVIRONMENT,
  // Tracing
  tracesSampleRate: 1.0, 
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


const App = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <PrimeReactProvider>
          <Authenticate />
          <Main />
        </PrimeReactProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
